<template>
  <div >
  	<img src="../../../assets/img/icon-phone.png">
  	<div class="kc-phone-table">
  		<div class="kc-phone-table-title">客服电话</div>
  		<div class="kc-phone-table-content">{{kefu.phone}}</div>
  	</div>
  </div>
</template>

<script>
  import {ApiGetcustomService} from '../../../net/course/index.js'
export default {
  data: function () {
    return {
      kefu : {
        phone : null,
        content : ''
      }
    }
  },
  methods:{
    getphone(){
      const param = {phoneType : 'pc'}
      ApiGetcustomService(param).then(res=>{
        if(res.code == 200){
          this.kefu = res.value
        }
      })
    }
  },
  mounted() {
    this.getphone()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CourseDetail/child/Detailphone.vue